import React, { Component } from "react";
import swal from "sweetalert";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import axios from "axios";
import LoadingOverlay from "react-loading-overlay";
import { ValidationForm, TextInput } from "react-bootstrap4-form-validation";
import { API_URL } from "../../../../BaseUrlApi/Url";
import "./AddVaccine.css";

const headers = {
  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  "Content-Type": "application/json",
};

const animatedComponents = makeAnimated();

class AddVaccine extends Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      immediate: true,
      setFocusOnError: true,
      clearInputOnReset: false,
      vaccine_name: "",
      vaccine_type: [],
      vaccine_types: [],
      isLoaded: false,
    };
  }

  async componentDidMount() {
    this.setState({ isLoaded: true });
    let getVaccineTypes = await axios.get(`${API_URL}/admin/vaccine_types`, {
      headers,
    });

    this.setState({
      vaccine_types: getVaccineTypes.data.data.map(item => {
        return {
          value: item.id,
          label: item.name
        }
      }),
    });
    this.setState({ isLoaded: false });
  }

  vaccineHandler = (value) => {
    console.log(value);
    if(value === null) {
      this.setState({
        vaccine_type: []
      })
    } else {
      this.setState({
        vaccine_type: [...value]
      })
    }
  }
  vaccineNameHandler = async (e) => {
    await this.setState({
      vaccine_name: e.target.value,
    });
  };

  saveVaccine = async (e) => {
    const postVaccine = {
      vaccine_type_ids: this.state.vaccine_type.map(itemx => (
        itemx.value
      )),
      brand_name: this.state.vaccine_name,
    };

    axios
      .post(`${API_URL}/admin/vaccines`, postVaccine, { headers })
      .then((res) => {
        swal({
          title: "Sukses!",
          text: "Tipe Vaksin Baru Telah Berhasil Ditambahkan!",
          icon: "success",
          button: "OK",
        }).then((move) => {
          if (move) {
            window.location.href = "/vaccines";
          } else {
            return;
          }
        });
      })
      .catch((err) => {
        swal({
          title: "GAGAL",
          text: "Lengkapi semua data terlebih dahulu",
          icon: "warning",
          type: "error",
          buttons: "OK",
        });
      });
  };
  cancelVaccine = () => {
    window.location.href = "/vaccines";
  };
  render() {
    return (
      <>
                <LoadingOverlay
          active={this.state.isLoaded}
          spinner
          text="Memuat data..."
        >
          <div className="content-section">
            <div className="title-section mb-5">
              <h1 className="patient-page-title">Tambah Vaksin</h1>
              <h2 className="patient-page-subtitle">
                <span style={{ color: "#039BEB" }}>Master Data</span>
                <span style={{ color: "#039BEB" }}>/ Daftar Vaksin</span>
                <span style={{ color: "#00000029" }}> / Tambah Vaksin</span>
              </h2>
            </div>
            <div className="card shadow mb-4">
              <div className="card-body">
                <ValidationForm
                  onSubmit={this.saveVaccine.bind(this)}
                  ref={this.formRef}
                  immediate={this.state.immediate}
                  setFocusOnError={this.state.setFocusOnError}
                >
                  <table cellPadding="10" className="add-table text-left">
                    <tbody>
                      <tr>
                        <td>
                          <label htmlFor="" className="add-vaccine-label">
                            Tipe Vaksin
                          </label>
                        </td>
                        <td>
                          
                          :
                          <Select
                              // style={{width: '1rem'}}
                            isMulti
                            closeMenuOnSelect={false}
                            components={animatedComponents}
                            // components={{ Placeholder }}
                            placeholder={'Pilih Tipe Vaksin'}
                            // styles={{
                            // placeholder: base => ({
                            //     ...base,
                            //     // fontSize: '1em',
                            //     color: 'black',
                            //     // fontWeight: 400,
                            // }),
                            // }}
                            options={this.state.vaccine_types}
                            value={this.state.vaccine_type}
                            onChange={(value) => {
                                this.vaccineHandler(value)
                            }}
                            required
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <label htmlFor="" className="add-vaccine-label">
                            Nama Vaksin
                          </label>
                        </td>
                        <td>
                          
                          :
                          <TextInput
                            type="text"
                            name="vaccineType"
                            onChange={this.vaccineNameHandler}
                            className="add-vaccine-input"
                            required
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ValidationForm>
                <div className="patient-buttons">
                  <button
                    className="btn btn-primary  "
                    onClick={this.saveVaccine}
                  >
                    Simpan
                  </button>
                  <button
                    className="btn btn-danger mr-1"
                    onClick={this.cancelVaccine}
                  >
                    Batal
                  </button>
                </div>
              </div>
            </div>
          </div>
        </LoadingOverlay>
      </>
    );
  }
}

export default AddVaccine;
